// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__2sPo2","vLegacy":"SelectSecondary_vLegacy__12ICz","error":"SelectSecondary_error__2_txU","disabled":"SelectSecondary_disabled__2iPKq"};